import React, { useState } from "react";
import Tilt from 'react-parallax-tilt';
import Lottie from "lottie-react";
// import animationData from "../../MyAnimations/Education.json";
import animationData from "../../MyAnimations/Animation - 1746443939947.json"

const ExperenceOverview = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 670);
  return (
    <div className="services-details-area" style={{backgroundColor : "#292930", color :"white"}}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-10">
          <div className="services-details-img text-center" style={{display : "flex", justifyContent : "center", alignItems : "center", marginTop : "-110px"}}>
        {/* <img src="/img/images/services_d  etails_img.png" alt="" />  */}
        <Lottie animationData={animationData} loop={true} style={{ width: isMobile ? "95%" : "60%", height: isMobile ? "95%" : "60%" }} />
    </div>

            <div className="services-details-content text-center" style={{marginTop :"20px"}}>
              <p>
              My professional experience has strengthened my ability to apply technical knowledge in real-world scenarios, enhancing my skills in full-stack development, project collaboration, and delivering scalable, user-centric solutions.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="services-details-shape">
        <img src="/img/images/services_details_shape.png" alt="" />
      </div>
    </div>
  );
};

export default ExperenceOverview;
